export default __webpack_public_path__ + "static/media/map.cd2a478b.svg";